<!--
     <FileInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → File() object

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
     - value (file url)
     - required_rule
     - accept
-->

<template>
  <div>
    <v-file-input
      v-model="file"
      :label="props.label"
      :placeholder="props.filename || props.placeholder"
      dense
      :disabled="props.readonly"
      :accept="!props.accept ? '/*' : props.accept"
    >
      <template v-slot:selection="{ index, text }">
        <span>
          {{ file ? text : props.filename || text }}
        </span>
      </template>
    </v-file-input>
    <div v-if="props.value">
      <v-btn @click="download" small> Ver actual </v-btn>
    </div>
  </div>
</template>


<script>
import QUnit from '@/api/QUnit'
import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'

export default {
  name: 'FileInput',

  props: ['props', 'required_rule', 'accept'],

  data: () => ({
    file: null,
  }),

  computed: {
    value() {
      return this.file
    },
    ...mapState([
      'sitePath',
      'isLoading',
      'message',
      'current_business_process',
      'current_unit',
    ]),
  },

  methods: {
    validate() {
      return !this.required || !!this.file
    },

    download() {
      console.log('kk')
      // console.log(this.sitePath, this.current_unit.uid, this.props)

      QUnit.getQUnitFile(
        this.sitePath,
        this.current_unit.uid,
        this.props.id,
        this.props.value,
      )
        .then((data) => {
          this.downloadFile(data, this.props.filename)
        })
        .catch((error) => console.log('handleEvidence', error))
      // window.open(this.props.value, '_blank')
    },
    downloadFile(data, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([data.data], { type: 'application/vnd' })

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob)
        return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const ob = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = ob
      link.download = filename //+ '.docx'
      link.click()
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(ob)
      }, 100)
    },
  },

  watch: {
    props(props) {
      if (!this.file && props.filename) this.file = File()
    },
  },
}
</script>
